module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1920-e3d4d61e73523aab34a4441b3a4e4d83.webp";